(function () {
  if (customElements.get('ce-product-media-thumbnails') !== undefined) {
    return;
  }

  class ProductMediaThumbnails extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        list: '[data-product-media-thumbnails-list]',
      };

      this.elements = null;

      this.schedule = rafSchd((deltaX, deltaY) => {
        let left = 0;
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
          left = this.elements.list.scrollLeft + deltaX * 0.75;
        } else {
          left = this.elements.list.scrollLeft + deltaY * 0.75;
        }

        this.elements.list.scrollTo({
          left: left,
          top: 0,
          behavior: 'instant',
        });
      });

      this._handleWheel = this._handleWheel.bind(this);
    }

    parsedCallback() {
      this.elements = {
        list: this.querySelector(this.selectors.list),
      };

      this.elements.list.addEventListener('wheel', this._handleWheel);
    }

    disconnectedCallback() {
      this.elements.list.removeEventListener('wheel', this._handleWheel);
    }

    _handleWheel(event) {
      event.preventDefault();
      this.schedule(event.deltaX, event.deltaY);
    }
  }

  customElements.define('ce-product-media-thumbnails', ProductMediaThumbnails);
})();
